module.exports = __webpack_public_path__ + "static/img/40020 (3).8c6f00e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40020 (3).webp
// module id = 7dlk
// module chunks = 14